import React from "react";

import { Container } from "./styles";

function Icon({ children, handleClick, ...rest }) {
  return (
    <Container type="button" onClick={handleClick} {...rest}>
      {children}
    </Container>
  );
}

export default Icon;
